//ready function start here
$(document).ready(function(){
  $(".category_sidebar").hide();
  $(".category_button").hover(function() {
  $('.category_sidebar').show();
    $(".category_sidebar").animate({
        "marginLeft": "+=100px"
    }, 700);
    $(".category_sidebar").show();
}, function() {
    $(".category_sidebar").animate({
        "marginLeft": "-=100px"
    }, 700);
   $('.category_sidebar').hide();
});
 $(document).on('click','.filter_heading',function(){
   $('.facets__wrapper').toggle();
 }); 

  $(".product-info-icon").hover(function(){
  var alt_val = $(this).attr('alt');
      $('.icon_text').show();
      $('.icon_text').text(alt_val);
    }, function(){
     $('.icon_text').hide();
  });

 
$('.insta_image-main').slick({
  infinite: true,
  slidesToShow: 5,
  dots: false,
  arrows: true,
  slidesToScroll: 1,
   responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
});
 /* setTimeout(function() { 
    alert($("product-form.product-form form input[name=section-id]").val());
  $("product-form.product-form form input").each(function(){
      if($(this).val()==""){
        alert("not value");
      }
    });
    }, 4000); */
});
//ready function end here 